import React from 'react';
import { Box, VStack, Heading, Text, Icon, Flex } from '@chakra-ui/react';
import {
  FiTool,
  FiClock,
  // FiMail
} from 'react-icons/fi';

const MaintenanceMode = () => {
  return (
    <Flex minH="100vh" align="center" justify="center" bg="bg.subtle" p={4}>
      <Box
        bg="bg.panel"
        borderRadius="xl"
        border="1px"
        borderColor="border.DEFAULT"
        p={{ base: 8, md: 12 }}
        boxShadow="xl"
      >
        <VStack spacing={6} align="center">
          <Box mb={4}>
            <img
              style={{ width: '120px', height: 'auto' }}
              src={window.location.hostname.includes('.agilechain') ? '/img/ac-logo.png' : '/img/BOAB_Blue.png'}
              alt="Logo"
            />
          </Box>

          <Box p={4} borderRadius="full" bg="blue.subtle" color="blue.fg">
            <Icon as={FiTool} boxSize={12} />
          </Box>

          <Heading size="xl" color="fg.DEFAULT" textAlign="center" fontWeight="bold">
            System Under Maintenance
          </Heading>

          <Text fontSize="lg" color="fg.muted" textAlign="center" maxW="md">
            We&apos;re currently performing scheduled maintenance to improve your experience. The system will be back
            online shortly.
          </Text>

          <Box bg="blue.subtle" borderRadius="lg" p={6} w="full" borderLeft="4px" borderColor="blue.solid">
            <VStack align="start" spacing={3}>
              <Flex align="center" gap={2}>
                <Icon as={FiClock} color="blue.fg" boxSize={5} />
                <Text fontWeight="semibold" color="fg.DEFAULT">
                  Maintenance Window
                </Text>
              </Flex>
            </VStack>
          </Box>

          {/* <Box bg="bg.muted" borderRadius="lg" p={6} w="full">
            <VStack align="start" spacing={3}>
              <Flex align="center" gap={2}>
                <Icon as={FiMail} color="blue.fg" boxSize={5} />
                <Text fontWeight="semibold" color="fg.DEFAULT">
                  Need Immediate Assistance?
                </Text>
              </Flex>
              <Text color="fg.muted" fontSize="sm">
                If you need urgent help during this maintenance window, please contact:
              </Text>
              <VStack align="start" spacing={1} pl={7}>
                <Text color="fg.muted" fontSize="sm">
                  • Jonathan - jonathan@fultonmarketgroup.com
                </Text>
                <Text color="fg.muted" fontSize="sm">
                  • Andy - andy@fultonmarketgroup.com
                </Text>
              </VStack>
            </VStack>
          </Box> */}

          <Text fontSize="sm" color="fg.subtle" textAlign="center" mt={4}>
            Thank you for your patience and understanding.
          </Text>

          <Box mt={4} p={3} bg="bg.subtle" borderRadius="md" borderTop="2px" borderColor="blue.muted" w="full">
            <Text fontSize="xs" color="fg.subtle" textAlign="center">
              Authorized personnel with special access can&nbsp;
              <Text as="a" href="/login" color="blue.fg" textDecoration="underline">
                log in here
              </Text>
              .
            </Text>
          </Box>
        </VStack>
      </Box>
    </Flex>
  );
};

export default MaintenanceMode;
